import {
  ProfileHeaderStyle,
  ProfileLayout,
  type ProfileButtonShape,
  type ProfileTheme,
} from '@up2stay/up2promo-api-client';

export type PublicProfileLayout = ProfileLayout;
export type PublicProfileHeaderStyle = ProfileHeaderStyle;
export type PublicProfileTheme = ProfileTheme;
export type PublicProfileButtonShape = ProfileButtonShape;

const LAYOUT_VALUES = new Set<string>(Object.values(ProfileLayout));
const HEADER_STYLE_VALUES = new Set<string>(Object.values(ProfileHeaderStyle));

export type PublicProfileStyling = {
  layout?: PublicProfileLayout | null;
  theme?: PublicProfileTheme | null;
  headerStyle?: PublicProfileHeaderStyle | null;
  headerImage?: { id?: string; path?: string } | null;
  accentColor?: string | null;
  buttonShape?: PublicProfileButtonShape | null;
};

export function resolvePublicProfileLayout(
  layout: PublicProfileLayout | null | undefined,
): PublicProfileLayout {
  if (layout != null && LAYOUT_VALUES.has(layout)) {
    return layout;
  }
  return ProfileLayout.CARDS;
}

export function resolvePublicProfileHeaderStyle(input: {
  headerStyle?: PublicProfileHeaderStyle | null;
  headerImagePath?: string | null;
}): PublicProfileHeaderStyle {
  if (input.headerStyle != null && HEADER_STYLE_VALUES.has(input.headerStyle)) {
    return input.headerStyle;
  }
  if (input.headerImagePath?.trim()) return ProfileHeaderStyle.IMAGE;
  return ProfileHeaderStyle.GRADIENT;
}

/** Desktop layout threshold — use with `@container/profile` queries. */
export const PROFILE_DESKTOP_MIN_WIDTH_PX = 880;
